import Vue from 'vue';
import { isEqual } from 'lodash-es';

export default function useActionBooking (bookingInStore, bookingChanges) {
  function editBooking (property, value) {
    const dirty = !isEqual(bookingInStore.value[property], value);
    if (dirty) Vue.set(bookingChanges.value, property, value);
    else Vue.delete(bookingChanges.value, property);
  }

  return {
    editBooking,
  };
}
